import type { StyleOption } from '../gql';

export const generateStyleOptionName = (styleOption: StyleOption): string => {
    const colourString =
        styleOption.masterColourName ?? String(styleOption.masterColourName);
    const variantString = styleOption.styleVariant?.styleVariantName
        ? `:${styleOption.styleVariant.styleVariantName}`
        : '';
    return `${colourString}${variantString}`;
};
